export const setTitle = (title: string) => {
  document.title = title;
};
